import { useState } from "react";
import { InsuranceFormType } from "../../models/forms/insurance";
import { InsuranceForm } from "./insuranceForm.component";
import { ApiInsuranceTypes } from "../../core/apis/insuranceTypes";
import { useHistory } from "react-router-dom";
import { AppRouteUi } from "../../config/appRoute";

export const AddInsurance = () => {
  const [value, setValue] = useState<InsuranceFormType>({
    name: "",
    displayName: "",
    subtitle:"",
    isDisabled: false,
    insuranceCounty: [],
  });

  const routeHistory = useHistory();

  const handleSaveCallback = async (data: InsuranceFormType) => {
    const res = await ApiInsuranceTypes.Add(data);
    if (res.data.isSuccess)
      routeHistory.length > 1
        ? routeHistory.goBack()
        : routeHistory.push(AppRouteUi.Root);
  };

  return (
    <InsuranceForm
      value={value}
      onChange={setValue}
      handleSave={handleSaveCallback}
    />
  );
};
